import * as React from 'react';
export const IcCycling = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.01 10.94c.38.57 1.01.9 1.69.9h1.51c.55 0 1-.45 1-1s-.45-1-1-1h-1.53l-1.25-1.89a2.02 2.02 0 00-2.59-.69L8.98 9.19c-.63.32-1.05.92-1.11 1.63-.06.71.24 1.38.8 1.8l2.38 1.79V18c0 .55.45 1 1 1s1-.45 1-1v-3.59c0-.63-.3-1.24-.81-1.62l-2.36-1.82 3.89-1.92 1.25 1.87-.01.02zM17.69 7.71a1.54 1.54 0 10-.001-3.081 1.54 1.54 0 00.001 3.08zM5.74 12.89C3.68 12.89 2 14.57 2 16.63c0 2.06 1.68 3.74 3.74 3.74 2.06 0 3.74-1.68 3.74-3.74 0-2.06-1.68-3.74-3.74-3.74zm0 5.48a1.741 1.741 0 010-3.48 1.741 1.741 0 010 3.48z'
      fill='currentColor'
    />
    <path
      d='M18.26 12.89c-2.06 0-3.74 1.68-3.74 3.74 0 2.06 1.68 3.74 3.74 3.74 2.06 0 3.74-1.68 3.74-3.74 0-2.06-1.68-3.74-3.74-3.74zm0 5.48a1.741 1.741 0 010-3.48 1.741 1.741 0 010 3.48z'
      fill='currentColor'
    />
  </svg>
);
